const status = [
  {id: 'registered', name: '등록'},
  {id: 'ready', name: '인증대기'},
  {id: 'certified', name: '인증완료'},
  {id: 'reject', name: '반려완료'},
]

export {status}
